import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDomain: null,
  selectedSystem: null,
  client: null,
};

export const createMapSlice = createSlice({
  name: "EIPCreateMap.slice",
  reducerPath: "EIPCreateMap",
  initialState,
  reducers: {
    resetNewMapLocation: (state) => {
      state.selectedDomain = null;
      state.selectedSystem = null;
      state.client = null;
    },
    updateNewMapLocation: (state, action) => {
      state.selectedDomain = action.payload.selectedDomain;
      state.selectedSystem = action.payload.selectedSystem;
      state.client = action.payload.client;
    },
  },
});

export const { resetNewMapLocation, updateNewMapLocation } =
  createMapSlice.actions;
